import React from 'react';
import { personalInfo, stats } from '../data/mockData';
import { useTheme } from '../context/ThemeContext';

const HeroSection = () => {
  const { isDark } = useTheme();
  
  return (
    <section id="hero" className="hero-section">
      {/* Title */}
      <div className="hero-title-container">
        <h1 className="hero-title">
          {personalInfo.title.split(' ')[0]} <span className="hero-title-faded">{personalInfo.title.split(' ').slice(1).join(' ')}</span>
        </h1>
        <p className="hero-description">
          {personalInfo.heroDescription}
        </p>
        <blockquote className="hero-quote">
          <p>"Sir, please pay your cellular bill this month or we will terminate your plan immediately."</p>
          <cite>-AT&T Customer Support Representative</cite>
        </blockquote>
      </div>

      {/* Stats Row */}
      <div className="stats-row">
        {stats.map((stat, index) => (
          <div key={index} className="stat-item">
            <span className="stat-value">{stat.value}</span>
            <span className="stat-label">{stat.label}</span>
            <span className="stat-label">{stat.sublabel}</span>
          </div>
        ))}
      </div>

      <style jsx>{`
        .hero-section {
          padding-bottom: 60px;
        }

        .hero-title-container {
          margin-bottom: 40px;
        }

        .hero-title {
          font-family: 'Poppins', sans-serif;
          font-size: clamp(48px, 8vw, 90px);
          font-weight: 700;
          color: ${isDark ? '#fff' : '#151312'};
          line-height: 0.95;
          letter-spacing: -0.02em;
          margin: 0 0 24px 0;
          transition: color 0.3s ease;
        }

        .hero-title-faded {
          color: ${isDark ? 'rgba(182, 180, 189, 0.2)' : 'rgba(21, 19, 18, 0.15)'};
        }

        .hero-description {
          font-family: 'Poppins', sans-serif;
          font-size: 16px;
          font-weight: 400;
          color: ${isDark ? '#998f8f' : '#64748b'};
          line-height: 1.6;
          max-width: 500px;
          margin: 0 0 24px 0;
          transition: color 0.3s ease;
        }

        .hero-quote {
          font-family: 'Poppins', sans-serif;
          font-size: 14px;
          font-style: italic;
          color: ${isDark ? '#998f8f' : '#64748b'};
          line-height: 1.6;
          margin: 0;
          max-width: 500px;
          padding-left: 16px;
          border-left: 2px solid rgba(244, 108, 56, 0.5);
          transition: color 0.3s ease;
        }

        .hero-quote p {
          margin: 0 0 6px 0;
        }

        .hero-quote cite {
          font-size: 13px;
          color: #f46c38;
        }

        .stats-row {
          display: flex;
          gap: 60px;
        }

        .stat-item {
          display: flex;
          flex-direction: column;
        }

        .stat-value {
          font-family: 'Poppins', sans-serif;
          font-size: 56px;
          font-weight: 600;
          color: ${isDark ? '#fff' : '#151312'};
          line-height: 1.2;
          letter-spacing: -0.01em;
          transition: color 0.3s ease;
        }

        .stat-label {
          font-family: 'Poppins', sans-serif;
          font-size: 14px;
          font-weight: 400;
          color: ${isDark ? '#998f8f' : '#64748b'};
          line-height: 1.2;
          letter-spacing: -0.01em;
          transition: color 0.3s ease;
        }

        @media (max-width: 768px) {
          .stats-row {
            gap: 30px;
            flex-wrap: wrap;
          }

          .stat-value {
            font-size: 40px;
          }

          .hero-title {
            font-size: clamp(36px, 10vw, 60px);
          }

          .hero-description {
            font-size: 14px;
          }
        }

        @media (max-width: 480px) {
          .hero-section {
            padding-bottom: 40px;
          }

          .hero-title-container {
            margin-bottom: 30px;
          }

          .hero-title {
            font-size: 32px;
            margin-bottom: 16px;
          }

          .stats-row {
            gap: 20px;
          }

          .stat-value {
            font-size: 32px;
          }

          .stat-label {
            font-size: 12px;
          }
        }
      `}</style>
    </section>
  );
};

export default HeroSection;
